module.exports = __webpack_public_path__ + "account/assets/oops-rhino-painter.547d3f53.svg";